module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/apps-211d36e9f3ca1123a4b430f29914d7c5.svg";